import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JpqlComponent } from '../jpql.component';

@Component({
  selector: 'app-jpql-parse',
  templateUrl: './jpql-parse.component.html',
  styleUrl: './jpql-parse.component.scss'
})
export class JpqlParseComponent {
  text = '';

  constructor(public dialogRef: MatDialogRef<JpqlComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {}
  ) { }

  parse(text: string, key: boolean): void {
    if (key) {
      if (this.text.charAt(0) !== "'") {
        this.text = "'" + text.replace(/[\n\t]/g, "', '") + "'";
      }
    } else {
      this.text = text.replace(/[\n\t]/g, ', ');
    }
  }


  closeModal() {
    this.dialogRef.close();
  }

}
